const Radio = ({ element, value = '', onChange }) => {
    return <ul key={`radio-${element.id}`}>
        {element.items.map((item, idx) =>
            <li key={`opt-${element.id}-${idx}`}>
                <input
                    type="radio"
                    name={item.name}
                    value={item.value}
                    onChange={() => onChange(item.value)}
                    checked={item.value === value ? true : false}
                />{item.label}
            </li>
        )}
    </ul>
}

export default Radio;